import { Alert, Box, Button, ButtonGroup, Flex, Text } from '@chakra-ui/react';

import ErrorSharpIcon from '@gamma/ui/icons/ErrorSharpIcon';
import { Modal } from '@gamma/ui/overlay';

interface EntraIdSettingsDeleteModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  labels: {
    title: string;
    warningTitle: string;
    warningDescription: string;
    warningResult: string;
    cancel: string;
    confirm: string;
  };
}

export const EntraIdSettingsDeleteModal = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  labels,
}: EntraIdSettingsDeleteModalProps) => {
  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      title={labels.title}
      footer={
        <ButtonGroup isDisabled={isLoading}>
          <Button variant="solid" colorScheme="gray" onClick={onClose}>
            {labels.cancel}
          </Button>
          <Button
            variant="solid"
            colorScheme="red"
            onClick={onConfirm}
            isLoading={isLoading}
            isDisabled={isLoading}
          >
            {labels.confirm}
          </Button>
        </ButtonGroup>
      }
      body={
        <Alert variant="subtle" status="warning" w="100%">
          <Flex>
            <ErrorSharpIcon color="yellow.100" mr={2} />
            <Box>
              <Text textStyle="body-md-bold">{labels.warningTitle}</Text>
              <Text>{labels.warningDescription}</Text>
              <Text>{labels.warningResult}</Text>
            </Box>
          </Flex>
        </Alert>
      }
    />
  );
};
